import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { AuthService } from './services';
import { msalInstance } from './config/msal-config';
import UserContext from './context/user.context';

export const MSALHandler = () => {
  const { user, setUser } = useContext(UserContext);
  const history = useHistory();
  const signIn = async account => {
    const lionLoginInfo = account;
    const idToken = account.idToken;
    const username = account.username;
    try {
      const signInResponse = await AuthService.signIn(username, '', true, idToken);
      let stateObject = {
        ...user,
        username: username,
        tokens: signInResponse?.data?.data?.tokens,
        name: signInResponse?.data?.data?.name,
        authenticated: true,
        loggedIn: true,
        isSSO: true,
        lionLoginInfo,
        role:
          signInResponse?.data?.data?.roles?.includes('ADMIN') ||
          signInResponse?.data?.data?.roles?.includes('SUPERADMIN')
            ? 'ADMIN'
            : '',
      };
      localStorage.setItem('user', JSON.stringify(stateObject));
      setUser(stateObject);
      history.push('/interstitial');
    } catch (err) {
      history.push('/signIn');
      console.log(err);
    }
  };
  useEffect(() => {
    try {
      const initializeMsal = async () => {
        await msalInstance.initialize();
        const result = await msalInstance.handleRedirectPromise();
        if (result && result.account) {
          signIn({ ...result.account, idToken: result.idToken });
        } else {
          const currentAccounts = msalInstance.getAllAccounts();
          if (currentAccounts.length === 1) {
            signIn(currentAccounts[0]);
          }
        }
      };

      msalInstance.addEventCallback(async event => {});
      initializeMsal();
    } catch (err) {
      history.push('/signIn');
    }
  }, []);
  return null;
};
